import styled from "styled-components";

export const UploadImageInputStyled = styled.div`
  width: 100%;

  .label {
    margin-bottom: 0.5rem;
    color: ${({ theme }) => theme?.COLORS?.BLUE_2 || "#2c3e50"};
    font-size: ${({ theme }) => theme?.FONT?.SIZE?.S14 || "14px"};
    font-family: ${({ theme }) =>
      theme?.FONT?.STYLE?.KANIT_REGULAR || "Kanit, sans-serif"};
    font-weight: 500;
  }

  .errors {
    margin-top: 4px;
    font-size: ${({ theme }) => theme?.FONT?.SIZE?.S12 || "12px"};
    color: ${({ theme }) => theme?.COLORS?.RED_1 || "#e74c3c"};
    font-family: ${({ theme }) =>
      theme?.FONT?.STYLE?.KANIT_REGULAR || "Kanit, sans-serif"};
  }

  .upload_container {
    position: relative;
    width: 100%;

    .box_upload {
      display: flex;
      width: 100%;
      border: 1px solid #f5f5f5;
      border-radius: 1rem;
      overflow: hidden;
      transition: all 0.3s ease;
      background: #ffffff;
      cursor: pointer;

      &:hover {
        border-color: ${({ theme }) => theme?.COLORS?.BLUE_3 || "#3498db"};
      }

      &.active {
        border-color: ${({ theme }) => theme?.COLORS?.BLUE_3 || "#3498db"};
        background: #f8f9fa;
      }

      &.uploading {
        border-color: #4caf50;
        cursor: not-allowed;
      }

      &.disabled {
        opacity: 0.6;
        cursor: not-allowed;
        background: #f5f5f5;

        .box_path,
        .btn_upload {
          cursor: not-allowed;
        }
      }

      .box_path {
        flex: 1;
        position: relative;
        border-top-left-radius: 1rem;
        border-bottom-left-radius: 1rem;

        .path_name {
          color: ${({ theme }) => theme?.COLORS?.BLUE_2 || "#2c3e50"};
          font-size: ${({ theme }) => theme?.FONT?.SIZE?.S13 || "13px"};
          font-family: ${({ theme }) =>
            theme?.FONT?.STYLE?.KANIT_REGULAR || "Kanit, sans-serif"};
          height: 2.75rem;
          padding: 0px 35px 0 15px;
          display: flex;
          align-items: center;
          border-top-left-radius: 1rem;
          border-bottom-left-radius: 1rem;
          user-select: none;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .upload_progress {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background-color: #e9ecef;
          overflow: hidden;

          .progress_bar {
            height: 100%;
            background: linear-gradient(90deg, #4caf50 0%, #45a049 100%);
            transition: width 0.3s ease;
            position: relative;

            &::after {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(
                90deg,
                transparent 0%,
                rgba(255, 255, 255, 0.3) 50%,
                transparent 100%
              );
              animation: shimmer 2s infinite;
            }
          }

          @keyframes shimmer {
            0% {
              transform: translateX(-100%);
            }
            100% {
              transform: translateX(100%);
            }
          }
        }

        .upload_status {
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translateY(-50%);
          font-size: 12px;
          font-family: ${({ theme }) =>
            theme?.FONT?.STYLE?.KANIT_REGULAR || "Kanit, sans-serif"};
          padding: 4px 8px;
          border-radius: 12px;
          animation: statusFade 0.3s ease-in;
          z-index: 2;

          &.success {
            background: #d4edda;
            color: #155724;
            border: 1px solid #c3e6cb;
          }

          &.error {
            background: #f8d7da;
            color: #721c24;
            border: 1px solid #f5c6cb;
          }

          @keyframes statusFade {
            from {
              opacity: 0;
              transform: translateY(-50%) scale(0.8);
            }
            to {
              opacity: 1;
              transform: translateY(-50%) scale(1);
            }
          }
        }
      }

      .btn_upload {
        background: #d7dae3;
        color: ${({ theme }) => theme?.COLORS?.BLUE_2 || "#2c3e50"};
        min-width: 72px;
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: ${({ theme }) => theme?.FONT?.SIZE?.S13 || "13px"};
        font-family: ${({ theme }) =>
          theme?.FONT?.STYLE?.KANIT_REGULAR || "Kanit, sans-serif"};
        transition: all 0.3s ease;
        border: 0.0625rem solid transparent;
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
        user-select: none;

        &:hover {
          background: #c5c9d3;
        }
      }
    }

    .remove_image {
      position: absolute;
      top: 3px;
      right: 78px;
      width: 20px;
      height: 20px;
      background: #e74c3c;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s ease;

      &:hover {
        background: #c0392b;
        transform: scale(1.1);
      }

      svg {
        width: 10px;
        height: 10px;
        color: white;
      }
    }
  }

  .input_upload_scale_label {
    margin-top: 2px;
    padding-left: 8px;
    color: ${({ theme }) => theme?.COLORS?.GRAY_2 || "#6c757d"}A6;
    font-size: ${({ theme }) => theme?.FONT?.SIZE?.S13 || "13px"};
    font-family: ${({ theme }) =>
      theme?.FONT?.STYLE?.KANIT_LIGHT || "Kanit, sans-serif"};
    line-height: 1.4;
  }

  /* Theme upload image styling */
  &.theme_upload_image {
    .upload_container .box_upload {
      border: 2px dashed #e1e5e9;

      &:hover {
        border-color: ${({ theme }) => theme?.COLORS?.BLUE_3 || "#3498db"};
        background: #f8f9fa;
      }

      &.active {
        border-color: ${({ theme }) => theme?.COLORS?.BLUE_3 || "#3498db"};
        background: #e3f2fd;
        animation: pulse 1s infinite;
      }

      &.uploading {
        border-color: #4caf50;

        .box_path .path_name {
          color: #4caf50;
          font-weight: 500;
        }

        .btn_upload {
          background: #4caf50;
          color: white;
        }
      }
    }
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .upload_container .box_upload {
      .box_path .path_name {
        padding: 0 20px 0 12px;
        font-size: 12px;
      }

      .btn_upload {
        min-width: 60px;
        padding: 0 12px;
        font-size: 12px;
      }
    }

    .remove_image {
      right: 65px !important;
    }
  }

  /* Focus states for accessibility */
  .box_upload:focus-within {
    outline: 2px solid ${({ theme }) => theme?.COLORS?.BLUE_3 || "#3498db"};
    outline-offset: 2px;
  }

  /* Uploaded Files List */
  .uploaded_files_list {
    margin-top: 12px;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
    background: #ffffff;

    .list_header {
      background: #f8f9fa;
      padding: 10px 15px;
      font-size: ${({ theme }) => theme?.FONT?.SIZE?.S14 || "14px"};
      font-family: ${({ theme }) =>
        theme?.FONT?.STYLE?.KANIT_MEDIUM || "Kanit, sans-serif"};
      color: ${({ theme }) => theme?.COLORS?.BLUE_2 || "#2c3e50"};
      border-bottom: 1px solid #e9ecef;
    }

    .file_item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 15px;
      border-bottom: 1px solid #f1f3f4;
      transition: background-color 0.2s ease;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background-color: #f8f9fa;
      }

      .file_info {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 4px;

        .file_name {
          font-size: ${({ theme }) => theme?.FONT?.SIZE?.S14 || "14px"};
          font-family: ${({ theme }) =>
            theme?.FONT?.STYLE?.KANIT_REGULAR || "Kanit, sans-serif"};
          color: ${({ theme }) => theme?.COLORS?.BLUE_2 || "#2c3e50"};
          word-break: break-word;
          &.file_link {
            color: ${({ theme }) => theme?.COLORS?.BLUE_3 || "#1058cb"};
            text-decoration: underline;
            cursor: pointer;
          }
        }

        .file_size {
          font-size: ${({ theme }) => theme?.FONT?.SIZE?.S12 || "12px"};
          font-family: ${({ theme }) =>
            theme?.FONT?.STYLE?.KANIT_REGULAR || "Kanit, sans-serif"};
          color: #6c757d;
        }

        .file_progress {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-top: 8px;

          .progress_bar_container {
            flex: 1;
            height: 6px;
            background-color: #e9ecef;
            border-radius: 3px;
            overflow: hidden;

            .progress_bar {
              height: 100%;
              background: linear-gradient(90deg, #4caf50 0%, #45a049 100%);
              transition: width 0.3s ease;
              border-radius: 3px;
            }
          }

          .progress_text {
            font-size: ${({ theme }) => theme?.FONT?.SIZE?.S11 || "11px"};
            font-family: ${({ theme }) =>
              theme?.FONT?.STYLE?.KANIT_REGULAR || "Kanit, sans-serif"};
            color: #4caf50;
            min-width: 35px;
            text-align: right;
          }
        }

        .file_progress_bottom {
          margin-top: 8px;
          width: 100%;

          .progress_bar_container {
            width: 100%;
            height: 8px;
            background-color: #e9ecef;
            border-radius: 4px;
            overflow: hidden;
            margin-bottom: 4px;

            .progress_bar {
              height: 100%;
              background: linear-gradient(90deg, #4caf50 0%, #45a049 100%);
              transition: width 0.3s ease;
              border-radius: 4px;
              position: relative;

              &::after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: linear-gradient(
                  90deg,
                  transparent 0%,
                  rgba(255, 255, 255, 0.3) 50%,
                  transparent 100%
                );
                animation: shimmer 2s infinite;
              }
            }
          }

          .progress_info {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .progress_text {
              font-size: ${({ theme }) => theme?.FONT?.SIZE?.S12 || "12px"};
              font-family: ${({ theme }) =>
                theme?.FONT?.STYLE?.KANIT_REGULAR || "Kanit, sans-serif"};
              color: #4caf50;
              font-weight: 500;
            }
          }

          @keyframes shimmer {
            0% {
              transform: translateX(-100%);
            }
            100% {
              transform: translateX(100%);
            }
          }
        }

        .file_status {
          margin-top: 4px;
          font-size: ${({ theme }) => theme?.FONT?.SIZE?.S12 || "12px"};
          font-family: ${({ theme }) =>
            theme?.FONT?.STYLE?.KANIT_REGULAR || "Kanit, sans-serif"};

          &.success {
            color: #155724;
          }

          &.error {
            color: #721c24;
          }
        }
      }

      .remove_file_btn {
        margin-left: 10px;
        flex-shrink: 0;
        cursor: pointer;
      }
    }
  }

  /* Animation */
  @keyframes pulse {
    0% {
      border-color: #3498db;
    }
    50% {
      border-color: #2980b9;
    }
    100% {
      border-color: #3498db;
    }
  }
`;
